import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { ClaimScore } from '../../icons/claim-score';

const pages = [
  { name: 'Home', url: '/' },
  { name: 'FAQs', url: '/faqs' },
  { name: 'Contact Us', url: '/contact' },
];

const query = graphql`
  query Header($id: StringQueryOperatorInput = {}) {
    template(id: $id) {
      instructions {
        text
      }
      authentication {
        loginForm
      }
    }
  }
`;

const Header = () => {
  const data = useStaticQuery(query);

  const { loginForm } = data.template.authentication;
  const { instructions } = data.template;

  const hasInstructions =
    Array.isArray(instructions) && instructions.length > 0;

  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="static" color="background">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <ClaimScore sx={{ display: { xs: 'flex' } }} />
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}></Box>
          <Box
            sx={{
              flexGrow: 1,
              display: {
                xs: 'none',
                md: 'flex',
              },
              ml: 7,
            }}
          >
            {pages.map((page) => (
              <Button
                LinkComponent={Link}
                to={page.url}
                key={page.name}
                onClick={handleCloseNavMenu}
                sx={{
                  my: 2,
                  color: 'black',
                  display: 'block',
                  ':hover': { backgroundColor: 'transparent' },
                }}
              >
                {page.name}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="App navigation menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  component={Link}
                  key={page.url}
                  to={page.url}
                  onClick={handleCloseNavMenu}
                >
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* {!loginForm && (
            <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
              <Button
                LinkComponent={Link}
                to={hasInstructions ? '/claim-instructions' : '/claim-form'}
                variant="contained"
                sx={{ my: 2, color: 'white', display: 'block' }}
                disableElevation
              >
                Submit a Claim
              </Button>
            </Box>
          )} */}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
